export const convertColorToRGB = colorArray => {
  if (Array.isArray(colorArray) && colorArray.length === 3) {
    return `rgb(${colorArray[0]}, ${colorArray[1]}, ${colorArray[2]})`;
  }
  return "rgb(0, 0, 0)"; // Default to black if invalid input
};

export function capitalizeFirstLetter(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
